import { useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css"; 

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

export default function PdfThumbnail({ pdfUrl }) {
  const [loaded, setLoaded] = useState(false);

  return (
    <div className="w-full h-[200px] overflow-hidden bg-gray-50 flex items-center justify-center">
      <Document
        file={pdfUrl}
        loading={
          <div className="text-xs text-gray-400">Loading preview...</div>
        }
        error={
          <div className="text-xs text-gray-400">Preview unavailable</div>
        }
        onLoadSuccess={() => setLoaded(true)}
      >
        <Page
          pageNumber={1}
          width={280}
          renderAnnotationLayer={false}
          renderTextLayer={false}
          className={`group-hover:scale-105 transition-transform duration-300 ${
            loaded ? "opacity-100" : "opacity-0"
          }`}
        />
      </Document>
    </div>
  );
}